/// <reference path="../../polaris-web-components.d.ts" />
import React, { Component } from 'react';
import { useCallback, useEffect, useState, useMemo } from "react";
import WatermarkImage from '../../assets/3129492.jpg';
import { getShopUrl, getExportConfig, getTrialStatus, ChargeUrl } from '../Services/CommonServices';
import { downloadMenuBulkResult, menuBulkCancel, MenuBulkPolling, DeleteMenuLogs,menuExportStatus, getMenuImportHistory } from '../Services/MenuService';
import { environment } from '../Services/environment';
import { validConversionPrice } from '../Validation/regex';
import ImportHistory from '../common/ImportHistory';
import ImportProcessing from '../common/ImportProcessing';
import { ValidationErrorModal } from '../common/ValidationErrorModal';
import { errorMetaModal, errorModal, WarningModal } from '../common/ErrorModal';
import { ToastMarkup } from '../common/ToastMarkup';
import ExportStatusCard from '../common/ExportStatusCard';
import MappingModal from '../common/MappingModal';
import TrialExpiredBanner from '../common/TrialExpiredBanner';
import { useNavigate } from 'react-router-dom';
// import { useNavigationHistory } from '@shopify/app-bridge-react';
const endpoint = environment.serverUrl;

export default function MenuItem({ blockUpload,eventSource }) {
    const navigate = useNavigate();
    // const {push} = useNavigationHistory();
    var queryString = window.location.search;
    var storeUrl = getShopUrl();
    const [mappedHeaders, setMappedHeaders] = useState({});
    const CHUNK_SIZE = 1048576; // 1MB
    const [file, setFile] = useState();
    const [logsLoading, setLogsLoading] = useState(false);
    const [rejectedFiles, setRejectedFiles] = useState();
    const hasError = rejectedFiles != null;
    const validFileTypes = ['.csv','.CSV','text/csv','.xlsx','.XLSX'];
    const handleDropZoneDrop = useCallback(
        (_dropFiles, acceptedFiles, _rejectedFiles) => {
            setUploadErrors(false);
            setIsUploadError(false);
            setBulkErrors([]);
            setFile(acceptedFiles[0])
            setRejectedFiles(_rejectedFiles[0])
        },
        [],
    );
    const [menu, setMenu] = useState([]);
    const [rootObjectCount, setRootObjectCount] = useState(0);
    const [exportConfig, setExportConfig] = useState(null);
    const [exportResult, setExportResult] = useState({});
    let isExportConfig = false;
    const [mutationType, setMutationType] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [uploadStatus, setUploadStatus] = useState(false);
    const [exportStatus, setExportStatus] = useState("");
    const [uploadErrors, setUploadErrors] = useState([]);
    const [isUploadError, setIsUploadError] = useState(false);
    const [exportBtnLoading, setExportBtnLoading] = useState(false);
    const [downloadSpinner, setDownloadSpinner] = useState(false);
    const [conversionPrice, setConversionPrice] = useState();
    const [configLoading, setConfigLoading] = useState(false);
    const [bulkStatus, setBulkStatus] = useState("");
    const [pollingResult, setPollingResult] = useState(undefined);
    const [bulkErrors, setBulkErrors] = useState([]);
    const [logs, setLogs] = useState([]);
    const [nxtButton, setNxtButton] = useState(true);
    const [prvButton, setPrvButton] = useState(true);
    const [loadingMap, setLoadingMap] = useState({});

    const pageSize = 10;
    let [pageNo, setPageNo] = useState(1);
    let [pageCount, setPageCount] = useState(0);
    const [bulkMetaErrors, setBulkMetaErrors] = useState([]);
    const [uploadWarningsList, setUploadWarningsList] = useState([]);
    // const handleChangeConversionPrice = useCallback((newValue) => { if (ValidatePrice(newValue)) { setConversionPrice(newValue) } }, []);
    
    const fileUpload = useMemo(() => 
        !file && <s-text>Click here to upload a file</s-text>
    , [file]);
    
    const uploadedFile = useMemo(() => 
        file && (
            <s-stack direction="inline" gap="small" align="center">
                <s-thumbnail
                    size="small"
                    alt={file.name}
                    source={
                        validFileTypes.includes(file.type)
                            ? window.URL.createObjectURL(file)
                            : ''
                    }
                />
                <div>
                    <s-text as="span">
                        {file.name}
                    </s-text>
                    <s-text as="p">
                        {file.size} bytes
                    </s-text>
                </div>
            </s-stack>
        )
    , [file]);

    const [popoverActive, setPopoverActive] = useState(false);
    const [errModalActive, setErrModalActive] = useState(false);
    const handleErrorChangeModal = useCallback(() => setErrModalActive(!errModalActive), [errModalActive]);
    const togglePopoverActive = useCallback(() => setPopoverActive((popoverActive) => !popoverActive), [],);
    const [uploadBtnLoading, setUploadBtnLoading] = useState(false);
    const [toast, setToast] = useState(false);
    const toggleToast = useCallback(() => setToast((toast) => !toast), []);
    const [processingMsg, setProcessingMsg] = useState('calculating items');
    const [catalogExtractMsg, setCatalogExtractMsg] = useState();
    const [menuDeleteStatus, setMenuDeleteStatus] = useState();
    const [metaDeleteStatus, setMetaDeleteStatus] = useState();
    const [splitMenu, setSplitMenu] = useState();
    const [stagedUploadProgress, setStagedUploadProgress] = useState();
    const [menuBulkCancelStatus, setBulkCancelStatus] = useState("")
    const [emailMarketingUpdate,setEmailMarketingUpdate] = useState(undefined);
    const [selectedExportFilters, setSelectedExportFilters] = useState([]);
    const [active, setActive] = useState(false);
    const [activeResource, setActiveResource] = useState(false);
    const handleChangeModal = useCallback(() => { if (!active) {  }  setActive(!active); }, [active]);
    // const handleResourceChangeModal = useCallback(() => { if (!activeResource) {  }  setActiveResource(!activeResource); }, [activeResource]);
    const [selectedType, setSelectedType] = useState("");
      const [menuResourceType, setMenuResourceType] = useState("metafield");
    const [totalMenuCount, setTotalMenuCount] = useState(null);
    const [exportFilterMsg, setExportFilterMsg] = useState(null);

    // Trial Authorization States
    const [trialInfo, setTrialInfo] = useState(null);
    const [showTrialBanner, setShowTrialBanner] = useState(false);

    const [isModalActive, setIsModalActive] = useState(false);
    const [ mapModalLodaing, setMapModalLoading] = useState(false);
    const [exportModalLoading,setExportModalLoading] = useState(false);
  // Example headers
  const [shopifyHeaders,setShopifyHeaders] = useState([]);
  const [catalogHeaders,setCatalogHeaders] = useState([]);
  const [formSubmit, setFormSubmit] = useState(false);
    useEffect(() => {
        getConfigExport();
        setFile(null);
        // deleteOlderLogs();
        // statusPolling();
        getLogs();
        checkExportStatus();
        loadTrialStatus(); // Load trial authorization
    }, []);


    useEffect(() => {
            if (exportStatus === "completed" || exportStatus === "failed") {
                getConfigExport();
            }
        }, [exportStatus]);

    // ========== Trial Authorization Functions ==========
    
    const loadTrialStatus = async () => {
        try {
            const data = await getTrialStatus(storeUrl);
            setTrialInfo(data);
            
            // Show banner if trial expired and no active charge
            if (data.isTrialExpired && !data.hasActiveCharge) {
                setShowTrialBanner(true);
            }
        } catch (error) {
            console.error('Error loading trial status:', error);
        }
    };

    const checkTrialAccess = () => {
        if (!trialInfo) return true; // Loading state, allow temporarily
        
        if (!trialInfo.canAccessApp) {
            setShowTrialBanner(true);
            return false;
        }
        return true;
    };

    const handleTrialBannerDismiss = () => {
        setShowTrialBanner(false);
    };

    const handleUpgradeAction = () => {
        
        navigate('/plans' + queryString);
    };
    
    // ========== End Trial Authorization Functions ==========

    // useEffect(() => {
    //     if(!blockUpload)
    //     {
    //     GetMenuFields();
    //     }
    // }, [selectedType]);


    useEffect(() => {
        if(formSubmit)
        {
            handleSubmit();
        }
    }, [mappedHeaders,formSubmit]);


    const handleSubmit = () => {
        const isTitleMapped = Object.keys(mappedHeaders).some((key) => key.toLowerCase() === "handle");
        if (isTitleMapped) {
            const jsonData = JSON.stringify(mappedHeaders);
            const formData = new FormData();
            formData.append('MappingData', jsonData);
            formData.append('File', file, file.name);
            formData.append('StoreUrl', storeUrl);
            formData.append('Type', menuResourceType === "metafield" ?  selectedType : menuResourceType);
            const requestOptions = {
              method: 'POST',
              body: formData,
            };
    
            fetch(endpoint + '/api/Menu/process-mappings', requestOptions)
              .then((response) => {
                if (response.status === 400) {
                  return response.json().then((errorData) => {
                    if (errorData.message.includes('metafields')) {
                      throw new Error(`Menu mapping: ${errorData.message}`);
                    }
                    else {
                      throw new Error(`Bad Request: ${errorData.message}`);
                    }
                  });
                } else if (!response.ok) {
                  throw new Error('Server Error');
                }
                return response.json();
              })
              .then((data) => {
              })
              .catch((error) => {
                if (error.message.startsWith('Bad Request')) {
                //   uploadError("server");
                }
                else if (error.message.startsWith('Metafields')) {
                //   uploadError("metafield");
                }
              })
              .finally(() => {
                setActive(false);
              });
            setActive(false);
          }
        else {
        //   setProductMappingError("Mapping the 'Handle' Shopify header is required.");
        //   setSaveTempLoading(false);
        }
      };


    useEffect(() => {
         if (eventSource) {
        eventSource.onmessage = (event) => {
            const data = event.data;
            if (data.includes("processing")) {
                setUploadBtnLoading(false);
                setIsUploadError(false);
                setPollingResult(undefined);
                setUploadStatus(true);
                setBulkStatus("processing");
                setProcessingMsg("validating");
                setEmailMarketingUpdate(undefined);
                setFile(null);
            }
            if (data.includes("menuValidation")) {
                const { menuValidation } = JSON.parse(data);

                if (menuValidation === true) {
                    setUploadBtnLoading(false);
                    setIsUploadError(false);
                    setBulkStatus("processing");
                    setProcessingMsg("calculating items");
                    setEmailMarketingUpdate(undefined);
                    setFile(null);
                } else {
                    setFile(null);
                    setBulkStatus("failed");
                    setUploadStatus(false);
                    setPollingResult(undefined);
                    setUploadBtnLoading(false);
                    setIsUploadError(true);
                    setErrModalActive(true);
                    setUploadErrors(JSON.parse(data));
                    
                }
            } else if (data.includes("menuuploading")) {
                setPollingResult(undefined);
                setUploadStatus(true);
                setProcessingMsg("uploading");
                setStagedUploadProgress(JSON.parse(data));
                setUploadBtnLoading(false);
                
            } else if (data.includes("Menu delete")) {
                setPollingResult(undefined);
                setUploadStatus(true);
                setProcessingMsg("Menu delete");
                setMenuDeleteStatus(JSON.parse(data));
            } else if (data.includes("MenuMetafield delete")) {
                setPollingResult(undefined);
                setUploadStatus(true);
                setProcessingMsg("Metafield delete");
                setMetaDeleteStatus(JSON.parse(data));
            } else if (data.includes("bulkId")) {
                const jsonObject = JSON.parse(data);
                if (jsonObject) {
                    const { status } = jsonObject;

                    if (status.toLowerCase() === "completed") {
                        setPollingResult(jsonObject);
                        setBulkStatus(status);
                        setUploadStatus(false);
                        getLogs();
                    } else if (status.toLowerCase() === "canceled") {
                        setUploadStatus(false);
                        setBulkStatus(status);
                        getLogs();
                    } else {
                        setUploadStatus(true);
                        setBulkStatus(status);
                        setPollingResult(jsonObject);
                    }
                }
            } else if (data.includes("MenuCatalog extract")) {
                const jsonObject = JSON.parse(data);
                setPollingResult(undefined);
                setUploadStatus(true);
                setBulkStatus("processing");
                setCatalogExtractMsg(jsonObject);
                setProcessingMsg("Catalog extract");
                setUploadBtnLoading(false);
            } else if (data.includes("Split menu")) {
                const jsonObject = JSON.parse(data);
                setPollingResult(undefined);
                setUploadStatus(true);
                setBulkStatus("processing");
                setProcessingMsg("Split menu");
                setUploadBtnLoading(false);
                setSplitMenu(jsonObject);
            } else if (data.includes("bulkop")) {
                const jsonObject = JSON.parse(data);
                if (jsonObject.status = "canceled") { setBulkStatus(false); setPollingResult(undefined); setBulkCancelStatus(""); getLogs(); }
                else {
                    setBulkCancelStatus(jsonObject.status);
                }
            } else if (data === "pong") {
            } else if (data === "menuDownloadComplete") {
                setDownloadSpinner(false);
                getConfigExport();
            }
            else if (data.includes("menufailed")) {
                setExportStatus("failed");
                setDownloadSpinner(false);
            }
            else if (data.includes("Export")) {
                if (exportConfig === null && !isExportConfig) {
                    isExportConfig = true;
                    
                }
                try{
                const jsonObject = JSON.parse(data);
                if (jsonObject) {
                    const { type, status,completedAt } = jsonObject;
                    if (type.includes("Product")) { setMutationType("product"); }
                    else if (type.includes("Menu")) { setMutationType("menu"); setExportResult(jsonObject);}
                    if(status.toLowerCase() === "completed" || status.toLowerCase() === "failed" || status.toLowerCase() === "expired")
                    {
                        setDownloadSpinner(false);
                        setExportBtnLoading(false);
                        if(type.includes("Menu"))
                        {
                            setExportResult(jsonObject);
                            setExportStatus(status.toLowerCase());
                            setExportCompletedAt(completedAt);
                        }

                        if(type === "MenuExport")
                                {
                                    setDownloadSpinner(false);
                                    setExportBtnLoading(false);
                                    // window.location.href = endpoint + '/api/Menu/download-previous-export?storeUrl=' + storeUrl;
                                }
                    }
                    setExportStatus(status.toLowerCase());
                }} catch (err) {
                    console.warn("Non-JSON message received:", data);
                }
            }

        }
    }
        

        return () => {
            if (eventSource) {
              eventSource.onmessage = null; // Remove the event handler
            }
          };
        }, [eventSource]);



    function next() {
        pageNo = pageNo + 1
        if (pageNo <= pageCount) {
            setPageNo(pageNo);
            getLogs();
            setPrvButton(true);
        }
        else { setNxtButton(false); setPrvButton(true); }
    }
    function prev() {
        pageNo = pageNo - 1
        if (pageNo >= 1) {
            setPageNo(pageNo);
            getLogs();
            setNxtButton(true)
        }
        else { setPrvButton(false); setNxtButton(true) }
    }

    // Track when to show modals
    const [showBulkErrorModal, setShowBulkErrorModal] = useState(false);
    const [showBulkMetaErrorModal, setShowBulkMetaErrorModal] = useState(false);
    const [showUploadWarningsModal, setShowUploadWarningsModal] = useState(false);

    function generateMenuErrorModal(errors) {
        console.log("error model menu called", errors);
        setBulkErrors(errors);
        
        // Open the modal using command after state update
        setTimeout(() => {
            const modal = document.getElementById('bulk-error-modal');
            if (modal) {
                console.log("Opening bulk error modal", modal);
                modal.dispatchEvent(new CustomEvent('command', { detail: { action: 'show' } }));
            }
        }, 0);
    }

    function generateMetafieldErrorModal(errors) {
        console.log("metafield error modal called", errors);
        setBulkMetaErrors(errors);
        
        setTimeout(() => {
            const modal = document.getElementById('bulk-meta-error-modal');
            if (modal) {
                console.log("Opening bulk meta error modal", modal);
                modal.dispatchEvent(new CustomEvent('command', { detail: { action: 'show' } }));
            }
        }, 0);
    }

    function generateUploadWarningsModal(warnings) {
        console.log("Upload Warnings generateUploadWarningsModal", warnings);
        setUploadWarningsList(warnings);
        
        setTimeout(() => {
            const modal = document.getElementById('upload-warnings-modal');
            if (modal) {
                console.log("Opening upload warnings modal", modal);
                modal.dispatchEvent(new CustomEvent('command', { detail: { action: 'show' } }));
            }
        }, 0);
    }

    // For compatibility with ImportHistory component (mainly used for customer imports)
    function generateCombinedErrorModal(menuErrors, metafieldErrors) {
        setBulkErrors(menuErrors || []);
        setBulkMetaErrors(metafieldErrors || []);
        
        setTimeout(() => {
            const modal = document.getElementById('bulk-error-modal');
            if (modal) {
                modal.dispatchEvent(new CustomEvent('command', { detail: { action: 'show' } }));
            }
        }, 0);
    }

    // Define inline modal component like Collections.js does
    const bulkResponseErrorModal = (
        <s-modal
            id="bulk-error-modal"
            size="large"
            heading="Failed menus"
            padding="none"
        >
            <s-table padding="none">
                <s-table-header-row>
                    <s-table-header>Sl No</s-table-header>
                    <s-table-header>Handle</s-table-header>
                    <s-table-header>Error</s-table-header>
                </s-table-header-row>
                <s-table-body>
                    {bulkErrors?.map(({ handle, userErrors }, index) => (
                        <s-table-row key={index}>
                            <s-table-cell>
                                <s-text type="strong">{index + 1}</s-text>
                            </s-table-cell>
                            <s-table-cell>
                                <s-text>{handle}</s-text>
                            </s-table-cell>
                            <s-table-cell>
                                <s-text tone="critical">
                                    {userErrors?.[0]?.message || 'Unknown error'}
                                </s-text>
                            </s-table-cell>
                        </s-table-row>
                    ))}
                </s-table-body>
            </s-table>
            
            <s-button 
                slot="primary-action"
                commandFor="bulk-error-modal"
                command="--hide"
            >
                Close
            </s-button>
        </s-modal>
    );

    const [exportCompletedAt, setExportCompletedAt] = useState('');
    // const [exportModalActive, setExportModalActive] = useState(false);
    // const exportModal = (
    //     <>
    //         <Modal
    //             primaryAction={{
    //                 content: 'Export',
    //                 onAction: exportAllMenu,
    //                 disabled: exportStatus === 'running' || exportStatus === 'failed' || uploadStatus || blockUpload ? true : false,
    //             }}
    //             open={exportModalActive}
    //             title="Export"
    //             onClose={() => {setExportModalActive(false)}}>
    //                 <Modal.Section>
    //                     <Banner
    //                         status={exportStatus === "completed" ? "success" : exportStatus === "failed" ? "critical" : "info"}
    //                         onDismiss={false}>
    //                         <Text>
    //                             {exportStatus === "completed" ?
    //                                 "Export " + (mutationType !== '' && mutationType !== undefined ? " " + mutationType : "") + " completed on " + new Date(exportCompletedAt).toLocaleDateString() + " at " + new Date(exportCompletedAt).toLocaleTimeString() + ". "
    //                                 : exportStatus === "" ?  "No previous export Found. Please export again." :  "Export " + (mutationType !== '' && mutationType !== undefined ? " " + mutationType : "") + " " + exportStatus + (exportStatus !== "failed" ? ". This may take a few moments." : ".")}
    //                             {exportStatus === "completed" && !downloadSpinner? <Link url="" onClick={() => {
    //                                 setDownloadSpinner(true);
    //                                 window.location.href = endpoint + '/api/Menu/download-previous-export?storeUrl=' + storeUrl;
    //                             }}>Download</Link> : downloadSpinner ? <Spinner  size="small" /> : null}
    //                         </Text>
    //                     </Banner>
    //                 </Modal.Section>
                    
    //         </Modal>
    //     </>
    // );


    // const modalSelectResource = (

    //     <>
    //         <Modal
    //             primaryAction={{
    //                 content: 'Next',
    //                 onAction: () => { FileUploadValidation(); handleResourceChangeModal(); },
    //                 disabled: menuResourceType === "" || menuResourceType === undefined || uploadStatus || blockUpload ? true : false,
    //             }}
    //             open={activeResource}
    //             title="Select Resource Type"
    //             onClose={() => handleResourceChangeModal()}
    //         >
    //             <Modal.Section>
    //                 <FormLayout>
    //                     <Select
    //                         label="Resource Type"
    //                         options={[
    //                             { label: "Metafield", value: "metafield" },
    //                             { label: "Metaobject", value: "metaobject" }
    //                         ]}
    //                         value={menuResourceType}
    //                         onChange={(value) => { setMenuResourceType(value); }}
    //                     />
    //                 </FormLayout>

    //             </Modal.Section>
    //         </Modal>
    //     </>
    // );
            

    // const modal = (
        
    //     <>
    //         <Modal
    //             primaryAction={{
    //                 content: 'Export',
    //                 onAction: () => { exportMenuByType();handleChangeModal(); },
    //                 disabled: !["completed", "", "canceled", "expired","failed"].includes(exportStatus) || !!uploadStatus || !!blockUpload || exportModalLoading,
    //             }}
    //             secondaryActions={[
    //                 {
    //                     plain: true,
    //                 }
    //             ]}
    //             open={active}
    //             title="Export"
    //             onClose={() => handleChangeModal()}
    //         >
    //             {exportModalLoading === false ?
    //                 <Modal.Section>
    //                     {/* <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginTop: '10px' }}> */}
    //                     <FormLayout>
    //                     <Select
    //                         label="Resource Type"
    //                         options={[
    //                             { label: "Metafield", value: "metafield" },
    //                             { label: "Metaobject", value: "metaobject" }
    //                         ]}
    //                         value={menuResourceType}
    //                         onChange={(value) => { setMenuResourceType(value);} }
    //                     />
    //                     {menuResourceType === "metafield" ? 
    //                     <Select
    //                         label="Type"
    //                         options={menu.map((option) => ({ label: option, value: option }))}
    //                         value={selectedType}
    //                         onChange={(value) => { setSelectedType(value)} }
    //                     /> : null }
    //                     </FormLayout>
    //                     {/* </div> */}

    //                 </Modal.Section>
                    
    //                 : <Page> <div style={{ textAlign: 'center', margin: '2rem auto', alignItems: 'center', display: 'flex', justifyContent: 'space-between', flexDirection: 'column', marginBottom: '1rem' }} ><Spinner size='small' /> </div></Page>}
    //             {exportFilterMsg !== null && (
    //                 <div style={{ display: 'flex', alignItems: 'center', marginTop: '1rem' }}>
    //                     <p style={{ color: 'green', marginRight: '0.5rem' }}>{exportFilterMsg}</p>
    //                 </div>
    //             )}

    //         </Modal>
    //     </>
    // );

    return (
        <s-page heading='Menu'>
            <s-link slot="breadcrumb-actions" href={'/dashboard?' + queryString}>Dashboard</s-link>
            <s-button 
                slot="primary-action"
                onClick={() => { exportAllMenus() }}
                disabled={exportStatus !== "running" && !uploadStatus && !blockUpload ? false : true}
            >
                {exportStatus !== "completed" && exportStatus !== "" ? (
                    <s-tooltip>
                        <span slot="trigger">
                            {exportBtnLoading ? <s-spinner size="small"></s-spinner> : <s-icon source="circle-down" />}
                            Export
                        </span>
                        <span slot="content">
                            {`${mutationType ? ` ${mutationType}` : ""} ${exportStatus}${exportStatus !== "failed" && exportStatus !== "canceled" ? ". This may take a few moments." : "."}`}
                        </span>
                    </s-tooltip>
                ) : (
                    <>
                        <s-icon source="circle-down" />
                        Export
                    </>
                )}
            </s-button>

            {/* Trial Expired Banner */}
            <TrialExpiredBanner
                show={showTrialBanner}
                remainingDays={trialInfo?.remainingTrialDays || 0}
                onDismiss={handleTrialBannerDismiss}
                onUpgrade={handleUpgradeAction}
            />

            {/* Main Card - Two columns layout with grid */}
            <s-stack gap="base">
            <s-section padding="base">
                <s-box padding="none">
                    <s-grid gridTemplateColumns="repeat(12, 1fr)" gap="large">
                        <s-grid-item gridColumn="span 6">
                            <s-stack gap="small">
                                {/* DropZone Section */}
                                <s-stack gap="small-100">
                                    <s-heading>Upload File</s-heading>
                                    <s-link onClick={() => openSampleFile()}>
                                        Download a sample file
                                    </s-link>
                                    
                                    <s-drop-zone
                                        multiple={false}
                                        accept=".csv,.xlsx"
                                        onInput={(event) => {
                                            const files = event.currentTarget.files;
                                            if (files && files.length > 0) {
                                                handleDropZoneDrop([], Array.from(files), []);
                                            }
                                        }}
                                    >
                                        {uploadedFile}
                                        {fileUpload}
                                    </s-drop-zone>
                                    
                                    <s-text color="subdued">
                                        Accepts .csv/.xlsx format. Maximum size: 20 MB
                                    </s-text>
                                </s-stack>

                                {/* Action Buttons Section */}
                                <s-stack gap="small-100">
                                    <s-stack direction="inline" gap="small">
                                        <s-button
                                            variant="primary"
                                            disabled={!file || uploadStatus || blockUpload || exportStatus === "running"}
                                            loading={uploadBtnLoading}
                                            onClick={() => FileUploadValidation()}
                                        >
                                            Upload
                                        </s-button>
                                        {/* <s-button 
                                            variant="secondary" 
                                            onClick={() => openSampleFile()}
                                        >
                                            Download sample
                                        </s-button> */}
                                    </s-stack>
                                    
                                    {hasError && (
                                        <s-text as="p" tone="critical">
                                            {`"${rejectedFiles?.name}" is not supported. File type must be .csv or .xlsx`}
                                        </s-text>
                                    )}
                                </s-stack>
                            </s-stack>
                        </s-grid-item>
                        
                        <s-grid-item gridColumn="span 6">
                            {/* Note Section with Image Watermark */}
                            <div style={{ position: 'relative' }}>
                                {/* Watermark Image Background */}
                                <div 
                                    style={{
                                        position: 'absolute',
                                        bottom: '-140px',
                                        right: '10px',
                                        width: '300px',
                                        height: '300px',
                                        backgroundImage: `url(${WatermarkImage})`,
                                        backgroundSize: 'contain',
                                        backgroundRepeat: 'no-repeat',
                                        backgroundPosition: 'bottom right',
                                        opacity: '0.15',
                                        pointerEvents: 'none',
                                        zIndex: 0
                                    }}
                                />
                                
                                {/* Note Content - On top of watermark */}
                                <div style={{ position: 'relative', zIndex: 1 }}>
                                    <s-stack gap="small-100">
                                        <s-heading>Note</s-heading>
                                        <s-unordered-list>
                                            <s-list-item>
                                                Menu items should include columns: <s-text type="strong">Handle, Title, URL, Position</s-text>
                                            </s-list-item>
                                            <s-list-item>
                                                Metafields use the format: <s-text type="strong">menu/namespace/metafield-name/type</s-text>
                                            </s-list-item>
                                            <s-list-item>
                                                To delete a metafield, end the header with <s-text type="strong">'/delete'</s-text>
                                            </s-list-item>
                                            <s-list-item>
                                                Parent menu items can be referenced by their handle to create nested menus
                                            </s-list-item>
                                        </s-unordered-list>
                                    </s-stack>
                                </div>
                            </div>
                        </s-grid-item>
                    </s-grid>
                </s-box>
            </s-section>
            </s-stack>
            
            <ImportProcessing
                bulkStatus={bulkStatus}
                uploadStatus={uploadStatus}
                pollingResult={pollingResult}
                setErrModalActive={setErrModalActive}
                processingMsg={processingMsg}
                catalogExtractMsg={catalogExtractMsg}
                stagedUploadProgress={stagedUploadProgress}
                splitItems={splitMenu}
                productDeleteStatus={menuDeleteStatus}
                metaDeleteStatus={metaDeleteStatus}
                productBulkCancelStatus={menuBulkCancelStatus}
                cancelBulk={cancelBulk}
                generateProductErrorModal={generateMenuErrorModal}
                generateMetafieldErrorModal={generateMetafieldErrorModal}
                emailMarketingUpdate={emailMarketingUpdate}
            />
            
            {(exportResult !== undefined && exportConfig !== null) || exportStatus === "running" ? 
               
                    <ExportStatusCard 
                        exportResult={exportResult} 
                        productProgress={rootObjectCount === undefined ? 0 : totalMenuCount !== null ? (totalMenuCount !== 0 ? ((rootObjectCount/totalMenuCount)*100) : 0) : 0} 
                        exportConfig={exportConfig} 
                        currentRoute="menu" 
                    />
                 : null}

            <s-box paddingBlockStart="base">
            <s-section padding="none">
                    <ImportHistory
                        logs={logs}
                        generateProductErrorModal={generateMenuErrorModal}
                        generateMetafieldErrorModal={generateMetafieldErrorModal}
                        generateUploadWarningsModal={generateUploadWarningsModal}
                        generateCombinedErrorModal={generateCombinedErrorModal}
                        downloadResult={downloadResult}
                        loadingMap={loadingMap}
                        logsLoading={logsLoading}
                        currentRoute="menu"
                    />
                    
                    {logs.length !== 0 && (
                        <s-stack direction="inline" align="center">
                            <s-pagination
                                has-previous={prvButton}
                                onPrevious={() => prev()}
                                has-next={nxtButton}
                                onNext={() => next()}
                            />
                        </s-stack>
                    )}
                {/* </s-box> */}
            </s-section>
            </s-box>
            
            {errorMetaModal({ bulkMetaErrors })}
            {WarningModal({ uploadWarnings: uploadWarningsList })}
            {bulkErrors.length > 0 ? bulkResponseErrorModal : null}
            {/* {exportModal} */}
            {/* {modal} */}
            {/* {modalSelectResource} */}
            <MappingModal
                active={isModalActive}
                setActive={setIsModalActive}
                shopifyHeaders={shopifyHeaders}
                catalogHeaders={catalogHeaders}
                setTypeSelected = {setSelectedType}
                mapModalLodaing={mapModalLodaing}
                setMappedHeaders={setMappedHeaders}
                setFormSubmit={setFormSubmit}
                currentRoute={"menu"}
                blockUpload = {blockUpload}
                menuResourceType = {menuResourceType}
            />
            {isUploadError ? <ValidationErrorModal
                errModalActive={errModalActive}
                handleErrorChangeModal={handleErrorChangeModal}
                uploadErrors={uploadErrors}
            /> : null}
            <ToastMarkup toast={toast} toggleToast={toggleToast} content={"Saved"} />

            {/* {resultDownloadErrorToast} */}

        </s-page>
        // </Frame>
    );

    async function downloadResult(op, bulkId) {
        setLoadingMap((prevLoadingMap) => ({ ...prevLoadingMap, [bulkId + "_" + op]: true }));
        try {
            await downloadMenuBulkResult(storeUrl, bulkId, op);
        } catch (error) {
            setLoadingMap((prevLoadingMap) => ({ ...prevLoadingMap, [bulkId + "_" + op]: false }));
        } finally {
            setLoadingMap((prevLoadingMap) => ({ ...prevLoadingMap, [bulkId + "_" + op]: false }));
        }
    }

    function openSampleFile() {
        window.open(environment.sampleMenuFile, '_blank');
      }


      function exportAllMenus() {
        // Check trial authorization
        if (!checkTrialAccess()) {
            return;
        }

        setExportStatus('running');
        setExportBtnLoading(true);
        setExportStatus("running");

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        };
        fetch(endpoint + '/api/Menu/menu-export?storeUrl=' + storeUrl, requestOptions)
            .then(response => {
                if (response.status === 200 && response !== null) {
                } else if (response.status === 400) {
                    return response.statusText;
                }
            })
            .catch(error => {
            });
        return;
    }

    async function cancelBulk(bulkId) {
        menuBulkCancel(storeUrl, bulkId).then(function (result) {
            setBulkCancelStatus("canceling");
            getLogs();
        });
    }

    async function uploadChunk(chunk, chunkIndex, totalChunks) {
        const formData = new FormData();
        formData.append('file', chunk);
        formData.append('chunkIndex', chunkIndex);
        formData.append('totalChunks', totalChunks);

        const response = await fetch(endpoint + '/api/Menu/file-validation-chunk', {
            method: 'POST',
            body: formData,
        });

        if (!response.ok) {
            throw new Error('Chunk upload failed');
        }
    }

    async function FileUploadValidation() {
        // Check trial authorization
        if (!checkTrialAccess()) {
            return;
        }

        console.log("file upload validation called",menuResourceType);
            setFormSubmit(false);
            if (file !== null) {
                // QueryOwnerTypes();
                setBulkCancelStatus("");
                setIsUploadError(false);
                setUploadErrors(false);
                setBulkErrors([]);
                setUploadBtnLoading(true);

                const totalChunks = Math.ceil(file.size / CHUNK_SIZE);
                let allChunksUploaded = true;

                try {
                    for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
                        const start = chunkIndex * CHUNK_SIZE;
                        const end = Math.min(start + CHUNK_SIZE, file.size);
                        const chunk = file.slice(start, end);

                        try {
                            await uploadChunk(chunk, chunkIndex, totalChunks);
                        } catch (error) {
                            allChunksUploaded = false;
                            setUploadBtnLoading(false);
                            setIsUploadError(true);
                            setUploadErrors({
                                errorType: "exception",
                                errors: ["File upload failed. Please try again."]
                            });
                            setErrModalActive(true);
                            break;
                        }
                    }

                    if (allChunksUploaded) {
                        const formData = new FormData();
                        formData.append('fileName', file.name);
                        formData.append('totalChunks', totalChunks);
                        formData.append('storeUrl', storeUrl);
                        formData.append('type', menuResourceType === "metafield" ? selectedType : menuResourceType);

                        fetch(endpoint + '/api/Menu/read-catalog-headers', {
                            method: 'POST',
                            body: formData,
                        })
                            .then(response => {
                                if (!response.ok) {
                                    throw new Error('Network response was not ok');
                                }
                                return response.json();
                            })
                            .then(data => {
                                // const defaultCSVHeaders = ["null"];
                                const fileHeaders = [data?.fileHeaders];
                                setCatalogHeaders(...fileHeaders);
                                const headersShopify = [data?.shopifyHeaders];
                                setShopifyHeaders(...headersShopify);
                                setIsModalActive(true);
                                setUploadBtnLoading(false);
                            })
                            .catch(error => {
                                setUploadBtnLoading(false);
                                setIsUploadError(true);
                                setUploadErrors({
                                    errorType: "exception",
                                    errors: ["Failed to process file headers. Please check your file format."]
                                });
                                setErrModalActive(true);
                            });
                    }
                } catch (error) {
                    setUploadBtnLoading(false);
                    setIsUploadError(true);
                    setUploadErrors({
                        errorType: "exception",
                        errors: ["An error occurred while uploading the file. Please try again."]
                    });
                    setErrModalActive(true);
                }
            }
        
    }


    function deleteOlderLogs() {
        DeleteMenuLogs(storeUrl).then(function (result) {
        });
    }


    function statusPolling() {
        MenuBulkPolling(storeUrl).then(function (result) {
            if (result !== null) {
                var status = result.status;
                if (status.toLowerCase() === "completed") {
                    setPollingResult(result);
                    setBulkStatus(status);
                    setUploadStatus(false);
                    getLogs();
                }
                else if (status.toLowerCase() === "canceled") {
                    setUploadStatus(false);
                    setBulkStatus(status);
                    getLogs();
                }
                else {
                    setUploadStatus(true);
                    setBulkStatus(status);
                    setPollingResult(result);
                }
            }
            else {
            }
        })
    }
    function checkExportStatus() {
        menuExportStatus(storeUrl).then(function (result) {
            setDownloadSpinner(true);
            if (result !== null) {
                var status = result?.status?.toLowerCase();
                var type = result.type
                if (status === "completed" && type === "menu") {
                    setMutationType(type);
                    setExportStatus(status)
                    setExportCompletedAt(result.completedAt)
                    setExportResult(result);
                    setDownloadSpinner(false);
                }
                else if (type === "menu" && status === "running" ) {
                    setMutationType(type);
                    setExportStatus(status)
                    setExportResult(result);
                    setDownloadSpinner(true);
                }
                else if (type === "menu" && status === "processing" ) {
                    setMutationType(type);
                    setExportStatus(status)
                    setExportResult(result);
                    setDownloadSpinner(true);
                }
                else if (status === "failed" && type === "menu") {
                    setDownloadSpinner(false);
                    setMutationType(type);
                    setExportResult(result);
                    setExportStatus("failed")
                    
                }

                else if (status === "failed" && type === "product") {
                    setExportStatus("completed")
                    setDownloadSpinner(false);
                }

                else if (type !== "menu" && status === "running" )
                {
                    setMutationType(type);
                    setExportStatus(status)
                    setExportResult(result);
                }

                else {
                    // setMutationType(type);
                    // setExportStatus("")
                    // checkPrevExport();
                    setExportResult(result);
                    setDownloadSpinner(false);
                }
            }
            else
            {
                setDownloadSpinner(false);
            }
        })
    }
    function ValidatePrice(price) {
        if (validConversionPrice.test(price)) {
            return true;
        }
        else {
            return false;
        }

    }

    function getLogs() {
        setLogsLoading(true);
        getMenuImportHistory(storeUrl, pageNo, pageSize).then(function (result) {
            if (result !== null) {
                setLogs(result.results);
                setPageCount((result.totalCount / pageSize) + 1);
                setLogsLoading(false);
            }
            else {
                setLogsLoading(false);
            }
        });
    }



    function getConfigExport() {
        getExportConfig(storeUrl,"menu").then(function (result) {
            if (result !== null) {
                setExportConfig(result);
                if (result.status === "completed") {
                    setExportBtnLoading(false);
                    setDownloadSpinner(false);
                    setExportStatus(result.status);
                    
                }
                else if (result.status  === "failed") {
                    setExportBtnLoading(false);
                    setDownloadSpinner(false);
                    setExportStatus(result.status);
                }
                else {
                    setExportBtnLoading(true);
                    setExportStatus(result.status);
                }
            }
        });
    }

    

   
}

